<template>
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
    <path v-if="name === 'back'" d="m15 4-8 8 8 8" />
    <path
      v-else-if="name === 'expand'"
      d="M14 4h6v6M20 4l-7 7M10 20H4v-6M4 20l7-7"
    />
    <path
      v-else-if="name === 'restore'"
      d="M20 4l-7 7m0-6v6h6M4 20l7-7m-6 0h6v6"
    />
    <template v-else-if="name === 'support'">
      <path d="M4 13v-2a8 8 0 0 1 16 0v2M20 17v1a4 4 0 0 1-4 4h-3" />
      <rect x="2" y="11" width="4" height="7" rx="2" />
      <rect x="18" y="11" width="4" height="7" rx="2" />
      <path d="M11 22h3" />
    </template>
    <template v-else-if="name === 'group'">
      <circle cx="9" cy="8" r="3" />
      <path
        d="M3 20v-2a6 6 0 0 1 12 0v2M16 5a3 3 0 0 1 0 6M18 14a5 5 0 0 1 3 4v2"
      />
    </template>
    <template v-else-if="name === 'agent'">
      <rect x="5" y="7" width="14" height="12" rx="4" />
      <path d="M12 3v4M3 11v4m18-4v4M9 15h6" />
      <circle cx="9" cy="11" r="1" />
      <circle cx="15" cy="11" r="1" />
    </template>
    <template v-else>
      <rect x="3" y="4" width="18" height="16" rx="3" />
      <path d="M10 4v16M6 8h1M6 12h1" />
    </template>
  </svg>
</template>
<script>
/** 双端共用导航图标；可访问名称和点击范围由外层按钮提供。 */
export default {
  name: "ChatNavigationIcon",
  props: {
    name: {
      type: String,
      default: "panel",
      validator: (value) =>
        [
          "back",
          "panel",
          "expand",
          "restore",
          "agent",
          "group",
          "support",
        ].includes(value),
    },
  },
};
</script>
<style scoped>
svg {
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  stroke: currentColor;
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
